import { RouteObject } from 'react-router';

import { externalFestivalRoutes } from './festival/externalFestivalRoutes';
import { externalSurveyRoutes } from './survey/externalSurveyRoutes';
import { externalVenueDatesRoutes } from './venue/externalVenueDatesRoutes';
import { externalVenueStructureRoutes } from './venue/externalVenueStructureRoutes';

export const externalRoutes: RouteObject[] = [
  ...externalFestivalRoutes,
  ...externalVenueStructureRoutes,
  ...externalVenueDatesRoutes,
  ...externalSurveyRoutes,
];
